import React from 'react';
import { Text, RichText, withSitecoreContext, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { CardGroupSection2Col as CardGroupSection2ColNPM } from '@rotaryintl/component-landing-pages';

const CardGroupSection2Col = ({ rendering, params: { ComponentId } = {}, fields: { Title, Description } = {} }) => {
  return (
    <CardGroupSection2ColNPM
      id={ComponentId}
      title={<Text field={Title} />}
      description={<RichText field={Description} />}
      cardsPlaceholder={<Placeholder name="cardgroupsection2col-cards" rendering={rendering} />}
    />
  );
};

export default withSitecoreContext()(CardGroupSection2Col);
